import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShowChartTooltipService {
  public subscriber: Subject<boolean> = new Subject<boolean>();


}
